import type {RouteRecordRaw} from "vue-router";

export const routeName = 'main';

export const route: RouteRecordRaw = {
    name: routeName,
    path: '/',
    component: () => import('@/pages/MainPage'),
};
